import { tns } from "tiny-slider"
import {observeImages} from "./_lazy-image";
import {intersectionObserve} from "./_intersection-observer";

function initDestinationCarousel(id) {
    const element = document.querySelector('.destination-carousel-container-' + id);
    if (!element) {
        return;
    }

    intersectionObserve(element, 0, 0, (element, intersectionRatio) => {
        if (element.classList.contains('loaded') || intersectionRatio === 0) {
            return;
        }

        element.classList.add('loaded');

        tns({
            container: '.destination-carousel-container-' + id,
            mode: 'carousel',
            items: 1,
            gutter: 24,
            loop: true,
            autoplay: false,
            controlsContainer: '.destinationControls-' + id,
            prevButton: '.destination-previous-' + id,
            nextButton: '.destination-next-' + id,
            navPosition: 'bottom',
            lazyload: false,
            responsive: {
                900: {
                    gutter: 42,
                    items: 2,
                }
            }
        });

        const observeCarouselImages = () => {
            const images = document.querySelectorAll(`.destination-carousel-container-${id} img.lazy`);
            observeImages(images);
        };

        observeCarouselImages()
        setTimeout(observeCarouselImages, 200);
    });
}

window.initDestinationCarousel = initDestinationCarousel;